import { t } from "@redotech/redo-i18n";

export function localizeFlowStepTitle(title: string): string {
  switch (title) {
    case "Action":
      return t("Action");
    case "Add conversation tag":
      return t("Add conversation tag");
    case "Add exchange order tags":
      return t("Add exchange order tags");
    case "Add return tag":
      return t("Add return tag");
    case "Add undeclared item":
      return t("Add undeclared item");
    case "A/B test":
      return t("A/B test");
    case "AI Return Reasons":
      return t("AI Return Reasons");
    case "AI Warranty Reasons":
      return t("AI Warranty Reasons");
    case "Assign to support agent":
      return t("Assign to support agent");
    case "Block":
      return t("Block");
    case "Multiple choice":
      return t("Multiple choice");
    case "Close chat":
      return t("Close chat");
    case "Combine label":
      return t("Combine label");
    case "Condition":
      return t("Condition");
    case "Customer response":
      return t("Customer response");
    case "Discount code name":
      return t("Discount code name");
    case "Do nothing":
      return t("Do nothing");
    case "Dynamic bundle adjustment":
      return t("Dynamic bundle adjustment");
    case "Capture evidence":
      return t("Capture evidence");
    case "Extended warranty upsell":
      return t("Extended warranty upsell");
    case "Shipping name":
      return t("Shipping name");
    case "Exchange shipping rates":
      return t("Exchange shipping rates");
    case "Mark as final sale return":
      return t("Mark as final sale return");
    case "Flag":
      return t("Flag");
    case "Information":
      return t("Information");
    case "Input":
      return t("Input");
    case "Make service request":
      return t("Make service request");
    case "Mark for manual review":
      return t("Mark for manual review");
    case "Actions":
      return t("Actions");
    case "Conditions":
      return t("Conditions");
    case "Override Adjustment":
      return t("Override Adjustment");
    case "Require send back":
      return t("Require send back");
    case "Assign grade":
      return t("Assign grade");
    case "Returns Center":
      return t("Returns Center");
    case "Base question":
      return t("Base question");
    case "Reject":
      return t("Reject");
    case "Return":
      return t("Return");
    case "Decision":
      return t("Decision");
    case "See orders":
      return t("See orders");
    case "Send Email":
      return t("Send Email");
    case "Send message":
      return t("Send message");
    case "Send SMS Message":
      return t("Send SMS Message");
    case "Separate labels":
      return t("Separate labels");
    case "Location":
      return t("Location");
    case "Sort":
      return t("Sort");
    case "Submit Claim":
      return t("Submit Claim");
    case "Submit Advanced Claim":
      return t("Submit Advanced Claim");
    case "Submit Repair":
      return t("Submit Repair");
    case "Submit Warranty":
      return t("Submit Warranty");
    case "Submit Advanced Warranty":
      return t("Submit Advanced Warranty");
    case "Submit Warranty Registration":
      return t("Submit Warranty Registration");
    case "Trigger":
      return t("Trigger");
    case "Agent verification":
      return t("Agent verification");
    case "Verify item variant":
      return t("Verify item variant");
    case "Wait":
      return t("Wait");
    case "New step":
      return t("New step");
    case "Add claim tag":
      return t("Add claim tag");
    case "Add warranty tag":
      return t("Add warranty tag");
    case "Return reason":
      return t("Return reason");
    case "Claim reason":
      return t("Claim reason");
    case "Warranty reason":
      return t("Warranty reason");
    case "Order date":
      return t("Order date");
    case "Issue compensation":
      return t("Issue compensation");
    case "Restocking":
      return t("Restocking");
    case "End":
      return t("End");
    case "Donate":
      return t("Donate");
    case "Phase":
      return t("Phase");
    default:
      return title;
  }
}

export function localizeFlowSidebarTitle(
  sidebarTitle: string,
  stepTitle: string,
): string {
  return sidebarTitle === stepTitle
    ? localizeFlowStepTitle(stepTitle)
    : sidebarTitle;
}

export function localizeFlowCategoryName(categoryName: string): string {
  switch (categoryName) {
    case "Steps":
      return t("Steps");
    case "Actions":
      return t("Actions");
    case "Service requests":
      return t("Service requests");
    default:
      return categoryName;
  }
}
